import { useIntl } from "react-intl";
import { SimpleEntityGridColumn } from "../grid/SimpleEntityGrid";

export default function useInvoicePerMonthColumns(): Array<SimpleEntityGridColumn> {
    const { formatMessage } = useIntl();

    const gridColumns: Array<SimpleEntityGridColumn> = [
        {
            field: "year",
            headerName: formatMessage({ id: "content.grid.col.year" }),
            pinned: "left",
            cellClass: "number-cell",
        },
        {
            field: "january",
            headerName: formatMessage({ id: "content.grid.col.january" }),
            valueGetter: ({ data }: any) => `${data.january || 0} €`,
            cellClass: "number-cell",
        },
        {
            field: "february",
            headerName: formatMessage({ id: "content.grid.col.february" }),
            valueGetter: ({ data }: any) => `${data.february || 0} €`,
            cellClass: "number-cell",
        },
        {
            field: "march",
            headerName: formatMessage({ id: "content.grid.col.march" }),
            valueGetter: ({ data }: any) => `${data.march || 0} €`,
            cellClass: "number-cell",
        },
        {
            field: "april",
            headerName: formatMessage({ id: "content.grid.col.april" }),
            valueGetter: ({ data }: any) => `${data.april || 0} €`,
            cellClass: "number-cell",
        },
        {
            field: "may",
            headerName: formatMessage({ id: "content.grid.col.may" }),
            valueGetter: ({ data }: any) => `${data.may || 0} €`,
            cellClass: "number-cell",
        },
        {
            field: "june",
            headerName: formatMessage({ id: "content.grid.col.june" }),
            valueGetter: ({ data }: any) => `${data.june || 0} €`,
            cellClass: "number-cell",
        },
        {
            field: "july",
            headerName: formatMessage({ id: "content.grid.col.july" }),
            valueGetter: ({ data }: any) => `${data.july || 0} €`,
            cellClass: "number-cell",
        },
        {
            field: "august",
            headerName: formatMessage({ id: "content.grid.col.august" }),
            valueGetter: ({ data }: any) => `${data.august || 0} €`,
            cellClass: "number-cell",
        },
        {
            field: "september",
            headerName: formatMessage({ id: "content.grid.col.september" }),
            valueGetter: ({ data }: any) => `${data.september || 0} €`,
            cellClass: "number-cell",
        },
        {
            field: "october",
            headerName: formatMessage({ id: "content.grid.col.october" }),
            valueGetter: ({ data }: any) => `${data.october || 0} €`,
            cellClass: "number-cell",
        },
        {
            field: "november",
            headerName: formatMessage({ id: "content.grid.col.november" }),
            valueGetter: ({ data }: any) => `${data.november || 0} €`,
            cellClass: "number-cell",
        },
        {
            field: "december",
            headerName: formatMessage({ id: "content.grid.col.december" }),
            valueGetter: ({ data }: any) => `${data.december || 0} €`,
            cellClass: "number-cell",
        },
    ];

    return gridColumns;
}
